import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export const Col = props => {
    const classes = classNames([props.textAlign ? 'navbar-top-' + props.textAlign : '', props.className]);
    return _jsx("div", Object.assign({ className: classes }, { children: props.children }));
};
